export default "__VITE_ASSET__xOnJWaKX__"